import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectStudentLoanPayDown } from '../../../../store/selectors/home/equity'
import { Format } from '../../..'
import { Heading, ProConList, Pro, Info } from '../../../shared/Gem/GemDetail'
import { studentDebt } from '../../../../constants/equity'
import { CUSTOMER_MESSAGES } from '../../../../constants/customerMessages'

const StudentDebt = () => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.studentDebtHeading'
        defaultMessage='The average student loan debt for federal loans was around {debt} in 2022. Using equity to pay off your loans could be an option as long you understand the associated risks.'
        values={{
          debt: <Format.Currency abbreviate value={studentDebt.average} />
        }}
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.studentDebtOne'
          defaultMessage='Home equity rates are often (but not always) less than student loans'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.studentDebtTwo'
          defaultMessage='Paying off student loans is a great way to establish credit history'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.studentDebtThree'
          defaultMessage='Equity lines and loans use your house as collateral and may disqualify you from many student debt forgiveness or cancellation programs'
        />
      </Info>
    </ProConList>
  </div>
)

export default {
  GemContainer: connect(state => ({
    qaTag: 'studentDebtGem',
    amount: selectStudentLoanPayDown(state)
  })),
  Detail: StudentDebt,
  topic: CUSTOMER_MESSAGES.HOMEOWNER_STUDENT_DEBT.topic,
  topicKey: CUSTOMER_MESSAGES.HOMEOWNER_STUDENT_DEBT.topicKey,
  question: CUSTOMER_MESSAGES.HOMEOWNER_STUDENT_DEBT.message
}
